<template>
    <div class="setting-wrap" v-loading="loading">
        <h4>界面文字与图片设置</h4>
        <div class="search">
            <label>搜索文字:</label>
            <el-input class="input" @clear="buildListData" placeholder="搜索value" v-model="searchVal" clearable/>
            <el-button type="primary" @click="searchFun">搜索</el-button>
        </div>
        <el-table
                class="table"
                height="100%"
                :data="settings">
            <el-table-column
                    prop="key"
                    width="250"
                    label="key">
            </el-table-column>
            <el-table-column
                    prop="value"
                    label="value">
                <template slot-scope="scope" >
                    <img v-if="scope.row.type == 'img'"
                         @click="imageList = ['/img/' + scope.row.value]"
                         :src="'/img/' + scope.row.value" width="50" height="50"/>
                    <span v-else>{{scope.row.value}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="300"
                    label="操作">
                <template  slot-scope="scope">
                    <el-button @click="changeValue(scope.row)">修改</el-button>
                    <!--<el-button @click="showPos(scope.row)">查看位置</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :visible.sync="updateDialog.showText"
                   v-loading="updateDialog.save"
                   width="400px"
                   title="修改文字">
            <div class="search" style="text-align: center">
                <label style="vertical-align: top;">文字:</label>
                <el-input class="input" type="textarea" rows="5" style="width:300px;" placeholder="value" v-model="updateDialog.textVal" clearable/>
            </div>
            <div slot="footer" class="footer-btn">
                <el-button type="primary" @click="saveText">保存</el-button>
                <el-button @click="updateDialog.showText = false">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="updateDialog.showImage"
                   v-loading="updateDialog.save"
                   width="400px"
                   title="修改文字">
            <div class="search" style="text-align: center">
                <label style="vertical-align: middle;">图片:</label>
                <el-upload
                        class="upload-view"
                        :action="uploadAction"
                        :show-file-list="false"
                        :auto-upload="false"
                        ref="uploadView"
                        :on-success="uploadSuccess"
                        :on-error="uploadError"
                        multiple
                        :limit="1">
                    <el-button size="small" type="primary">选择</el-button>
                </el-upload>
                <!--<div class="upload-tip">只能上传jpg/png文件，且不超过500kb</div>-->
            </div>
            <div slot="footer" class="footer-btn">
                <el-button type="primary" @click="saveImage">保存</el-button>
                <el-button @click="updateDialog.showImage = false">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="updateDialog.showList"
                   v-loading="updateDialog.save"
                   width="400px"
                   title="修改列表">
            <div class="search" style="text-align: center">
                <div class="text-right">
                    <el-button @click="addToList">添加</el-button>
                </div>
                <el-table :data="updateDialog.textVal" v-if="updateDialog.select && updateDialog.select.type == 'list'">
                    <el-table-column v-for="item in updateDialog.select.len" :key="item">
                        <template slot-scope="scope">
                            {{scope.row[item - 1]}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="danger" size="mini" @click="deleteList(scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="footer-btn">
                <el-button type="primary" @click="saveList">保存</el-button>
                <el-button @click="updateDialog.showList = false">取消</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="add.show"
                   width="400px">
            <div class="search" style="text-align: center; margin-bottom:10px;" v-for="item in add.len" :key="item">
                <label style="vertical-align: top;">文字:</label>
                <el-input class="input" style="width:300px;" placeholder="value" v-model="add.vals[item - 1]" clearable/>
            </div>
            <div slot="footer" class="footer-btn">
                <el-button type="primary" @click="saveToList">保存</el-button>
                <el-button @click="add.show = false">取消</el-button>
            </div>
        </el-dialog>
        <image-viewer
                v-if="imageList.length > 0"
                :on-close="() => {imageList = []}"
                :url-list="imageList"
        ></image-viewer>

    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import ImageViewer from '@/components/ImageViewer';
    import {getHost} from "../api/link";

    export default {
        name: "Setting.vue",
        components: { ImageViewer },
        data(){
            return {
                uploadAction: getHost() + '/upload',
                imageList: [],
                settings: [],
                loading: false,
                config: null,
                searchVal: '',
                updateDialog: {
                    save: false,
                    showText: false,
                    showImage: false,
                    showList: false,
                    select: null,
                    textVal: '',
                },
                add: {
                    show: false,
                    len: 0,
                    vals: [],
                }
            }
        },
        created() {
            this.loading = true;
            this.getConfig()
                .then(res => {
                    this.config = res;
                    this.buildListData();
                    this.loading = false;
                })
                .catch(e => {
                    console.error(e);
                    this.$error('获取配置列表失败, 是否未开启服务器!');
                })
        },
        methods: {
            ...mapActions(['getConfig', 'setConfig']),
            searchFun() {
                if(this.searchVal == '') {
                    this.buildListData();
                    return ;
                }
                let arr = [];
                this.settings.forEach(v => {
                   if(v.value.indexOf(this.searchVal) != -1) {
                       arr.push(v);
                   }
                });
                this.settings = arr;
            },
            buildListData() {
                let arr = [];
                Object.keys(this.config).forEach(k => {
                    let obj = this.config[k];
                   arr.push({
                       ...obj,
                       key: k,
                   })
                });
                this.settings = arr;
            },
            changeValue(val) {
                this.updateDialog.select = val;
                this.updateDialog.textVal = val.value;
                if(val.type == 'text') {
                    this.updateDialog.showText = true;
                } else if(val.type == 'img') {
                    this.updateDialog.showImage = true;
                } else if(val.type == 'list') {
                    this.updateDialog.showList = true;
                }
            },
            addToList(){
                this.add.len = this.updateDialog.select.len;
                this.add.vals = [];
                for(let i = 0; i < this.add.len; i ++){
                    this.add.vals.push('');
                }
                this.add.show = true;
            },
            saveToList() {
                this.updateDialog.select.value.push(this.add.vals);
                this.add.show = false;
                this.$success('已添加');
            },
            deleteList(index) {
                this.updateDialog.select.value = this.updateDialog.select.value.splice(index, 1);
            },
            saveText() {
                this.updateDialog.select.value = this.updateDialog.textVal;
                this.config[this.updateDialog.select.key].value = this.updateDialog.textVal;
                this.saveToConfig();
            },
            saveImage() {
                this.updateDialog.save = true;
                this.$refs.uploadView.submit();
            },
            saveList() {
                this.saveToConfig();
            },
            uploadSuccess(res) {
                console.log(arguments);
                if(res.state == 0) {
                    this.updateDialog.select.value = res.name;
                    this.config[this.updateDialog.select.key].value = res.name;
                    this.saveToConfig();
                }
                this.$refs.uploadView.clearFiles();
            },
            uploadError() {
                this.$error('上传文件失败!');
                this.$refs.uploadView.clearFiles();
                this.updateDialog.save = false;
            },
            saveToConfig() {
                this.updateDialog.save = true;
                this.setConfig({
                    key: this.updateDialog.select.key,
                    value: this.updateDialog.select.value,
                })
                    .then(res => {
                        this.updateDialog.save = false;

                        if(res.state == 1) {
                            this.$error('保存失败');
                        } else {
                            this.updateDialog.showText = false;
                            this.updateDialog.showImage = false;
                            this.updateDialog.showList = false;
                            this.$success('保存成功');
                        }
                    })
                    .catch(e => {
                        this.updateDialog.save = false;
                        console.error(e);
                        this.$error('保存失败');
                    })
            },
            showPos(item) {
                console.log(item);
            }
        }
    }
</script>

<style scoped lang="less">
.setting-wrap {
    padding: 0 20px 20px;
    height: 100%;
    display: flex;
    flex-direction: column;

    h4{
        flex-shrink: 0;
        text-align: center;
    }



    .table {
        flex-grow: 1;
        font-size: 14px;
    }

}

.search {
    .input {
        width: 200px;
        margin: 0 10px;
    }
}

.footer-btn {
    text-align: center;
}

    .upload-view{
        display: inline-block;
    }
    .upload-tip{
        font-size: 12px;
        color: #f00;
    }
</style>
